import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { findProductById } from '../data/product';

const ProductDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const product = findProductById(id);

  if (!product) {
    return (
      <section className="product-detail-section">
        <div className="product-detail">
          <div>
            <h1 className="product-detail-title">Không tìm thấy sản phẩm</h1>
            <button className="product-button" onClick={() => navigate(-1)}>Quay lại</button>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="product-detail-section">
      <div className="product-detail">
        <div className="product-detail-image">
          <img src={product.img} alt={product.name} />
        </div>
        <div className="product-detail-info">
          <h1 className="product-detail-title">{product.name}</h1>
          <p>{product.content}</p>
          <ul>
            {product.features.map((f, i) => <li key={i}>{f}</li>)}
          </ul>
          <p className="product-detail-desc" style={{ color: '#000', fontStyle: 'italic' }}>{product.desc}</p>
          <p><b>Xuất xứ:</b> {product.origin}</p>
          <p><b>Chất liệu:</b> {product.material}</p>
          <div className="product-detail-price">Coming Soon</div>
          <div className="product-detail-actions">
            <button className="product-button" onClick={() => navigate(-1)}>Quay lại</button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductDetailPage;


